import { RowData } from '@tanstack/react-table';

import { useUrlSorting } from '../hooks/useUrlSorting';
import { useTableContext } from '../table.context';

type UrlSortingClientProps<TData extends RowData> = Parameters<typeof useUrlSorting<TData>>[0];

const UrlSortingClientComponent = <TData extends RowData>({
  getAllColumns,
  setSorting,
  resetSorting,
}: UrlSortingClientProps<TData>) => {
  useUrlSorting({
    getAllColumns,
    setSorting,
    resetSorting,
  });
  return null;
};
/** Renders the url sorting hook, does not render if the table is in pdf mode */
const UrlSortingClient = <TData extends RowData>({ ...props }: UrlSortingClientProps<TData>) => {
  const { table } = useTableContext();
  if (table.options.meta?.isPdf) return null;
  return <UrlSortingClientComponent {...props} />;
};

export { UrlSortingClient };
